/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type RemoteActionExecutionUpdateDto = {
  /**
   * New status for remote action
   */
  status: RemoteActionExecutionUpdateDto.status;
};
export namespace RemoteActionExecutionUpdateDto {
  /**
   * New status for remote action
   */
  export enum status {
    CANCELED = 'CANCELED',
  }
}

